import { render } from "./TrListPage.vue?vue&type=template&id=713f5172&scoped=true"
import script from "./TrListPage.vue?vue&type=script&lang=js"
export * from "./TrListPage.vue?vue&type=script&lang=js"

import "./TrListPage.vue?vue&type=style&index=0&id=713f5172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713f5172"]])

export default __exports__